class ArticleRecommendations extends HTMLElement {
  connectedCallback() {
    queueMicrotask(() => {
      if (!this.isConnected || this.swiper || !window.Swiper) return;

      const count = this.querySelectorAll('.swiper-slide').length;
      if (!count) return;

      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.updateMotion = () => {
        if (this.swiper) this.swiper.params.speed = this.motionQuery.matches ? 0 : 300;
      };
      this.swiper = new window.Swiper(this, {
        speed: this.motionQuery.matches ? 0 : 300,
        watchOverflow: true,
        breakpoints: {
          280: { slidesPerView: Math.min(1.7, count), spaceBetween: 15 },
          768: { slidesPerView: 3, spaceBetween: 18 },
          1400: { slidesPerView: 3, spaceBetween: 30 }
        }
      });
      this.motionQuery.addEventListener('change', this.updateMotion);
    });
  }

  disconnectedCallback() {
    this.motionQuery?.removeEventListener('change', this.updateMotion);
    this.swiper?.destroy(true, true);
    this.swiper = null;
  }
}

if (!customElements.get('article-recommendations')) {
  customElements.define('article-recommendations', ArticleRecommendations);
}
